'use client';
import { useTranslations } from 'next-intl';
import { InputLikeSelectTrigger } from '../SelectInput/InputTrigger';
import { IconCheck } from '@tabler/icons-react';
import { FilterSubPanel } from '../../SearchFiltersList/FilterSubPanel';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { createPortal } from 'react-dom';

type Props = {
  selected?: string;
  onChange?: (newSelected: string) => void;
  showModal: (id: string) => void;
  closeModal: (id: string) => void;
  openedModal: string;
};

export const MobileSortSwitch: React.FC<Props> = ({ selected, onChange, showModal, closeModal, openedModal }) => {
  const t = useTranslations('filtersScreen');

  const handleChange = (newVal: string) => {
    onChange?.(newVal);
  };

  const data = [
    { label: t('sortByNewest'), value: 'createdAt|desc' },
    { label: t('sortByCheapest'), value: 'price|asc' },
    { label: t('sortByExpensive'), value: 'price|desc' },
  ];
  const target = document.getElementById('mobile-filters-modal-parent');
  return (
    <div className='w-full'>
      {target &&
        openedModal === 'sort' &&
        createPortal(
          <FilterSubPanel title={t('sort')} onBack={() => closeModal?.('sort')} bodyClassName='px-[8px]'>
            <ToggleGroup
              type='single'
              orientation='vertical'
              spacing={1}
              value={selected}
              onValueChange={(value) => {
                if (value) {
                  handleChange(value);
                  closeModal?.('sort');
                }
              }}
              aria-label={t('sort')}
              className='w-full flex-col items-stretch gap-[2px]'
            >
              {data.map((item) => (
                <ToggleGroupItem
                  key={item.value}
                  value={item.value}
                  className='h-auto min-h-[48px] w-full justify-between rounded-[10px] px-[12px] text-[16px] font-normal text-text-primary-day hover:bg-bg2-day hover:text-text-primary-day data-[state=on]:bg-light-green data-[state=on]:text-text-primary-day'
                >
                  <span>{item.label}</span>
                  {selected === item.value && <IconCheck className='size-[20px] text-primary-green-day' />}
                </ToggleGroupItem>
              ))}
            </ToggleGroup>
          </FilterSubPanel>,
          target,
        )}
      <InputLikeSelectTrigger
        showHasValue={false}
        label={t('sort')}
        current={selected === '' ? '' : data.find(({ value }) => value === selected)?.label}
        onClick={() => {
          showModal?.('sort');
        }}
      />
    </div>
  );
};
